import { toast } from "react-toastify"

// Language across the app should be formatted as "User created successfully"

const successToast = (message) => toast.success(message)

export default successToast
